'use client';

import clsx from 'clsx';
import { Button } from '@nf/ui';
import { DropdownIcon } from '@/components/icons/svg-icons';
import { SportsOrder } from './sports-order';
import { useMenuEditSection } from '../../contexts/menu-edit-section-context';
import { useRef } from 'react';
import { useOuterClick } from '@nf/utils-common/hooks';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useAnalyseAttribute } from '@/features/next-analyse';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { sportMenuStyle } from '../../sports-menu.style';

export const SportsMenuItemEdit = ({ }) => {
	const { isMenuOpen, setIsMenuOpen, setIsEdit, setIsReset, setIsFirst } = useMenuEditSection();
	const menuTips = useRef<HTMLDivElement>(null);
	useOuterClick(menuTips, () => handleClick(false));
	const view = useAppearanceStore(state => state.view);
	const analyseAttributeRef = useAnalyseAttribute('toggle-top-menu-more-button');

	const handleIsMenuOpen = (outerClick = true) => {
		// 202405 已棄用 GalaxyV1, 若欲重開此功能請重新設計埋點
		// if (outerClick) {
		// 	const kafkaData = {
		// 		type: 3,
		// 		action: 7	
		// 	}
		// 	setKafkaNormal(kafkaData);
		// }
		setIsMenuOpen(outerClick ? !isMenuOpen : false);
	}
	const handleClick = (outerClick = true) => {
		handleIsMenuOpen(outerClick);
		setIsEdit(false);
		setIsReset(false);
		setIsFirst(true);
	}

	return (
		<>
			<Button
				ref={analyseAttributeRef}
				variant="icon"
				data-open={isMenuOpen}
				onClick={() => handleClick()}
				className={sportMenuStyle.moreButton}
			>
				<DropdownIcon />
			</Button>

			<div
				className={clsx('sports-menu__expand container', sportMenuStyle.expandContainer)}
				data-open={isMenuOpen}
				ref={menuTips}
			>
				<div className={clsx(
					'sports-menu__expand-wrap',
					{ 'scrollbar': view !== ViewEnum.mars },
					sportMenuStyle.expandWrap
				)}
				>
					<SportsOrder handleClose={() => handleClick()} />
				</div>
			</div>
		</>
	);
};